var getPathName = function () { return window.location.pathname; };
var isLoginPage = function () { return getPathName().startsWith('/login'); };
export var isHomePage = function () { return getPathName() === '/'; };
export var isContentMgtPage = function () {
    return getPathName().startsWith('/lcm/cms');
};
export var isShellApp = function () { return !getPathName().startsWith('/lcm'); };
export var isUserMgtApp = function () {
    return getPathName().startsWith('/lcm/authzn');
};
var getLoginUrl = function (preservePath, sessionTimeout) {
    var params = new URLSearchParams();
    if (preservePath) {
        var dest = getPathName() !== '/' && !isLoginPage()
            ? window.location.pathname +
                (window.location.search ? window.location.search : '')
            : undefined;
        if (dest) {
            params.append('dest', dest);
        }
        if (sessionTimeout) {
            params.append('sessionTimeout', 'true');
        }
    }
    return "/login" + (params.toString() ? "?" + params.toString() : '');
};
export var absoluteRedirect = function (url, newTab) {
    if (newTab === void 0) { newTab = false; }
    if (newTab) {
        window.open(url, '_blank');
    }
    else {
        window.location.href = url;
    }
    return null; // This will not render anything on UI if called from JSX
};
export var redirectToLoginPage = function (preservePath, sessionTimeout) {
    return !isLoginPage() && absoluteRedirect(getLoginUrl(preservePath, sessionTimeout));
};
/**
 *
 * @param dest - for redirection to target page after login is completed. Only login page should use this param
 */
export var redirectToHomePage = function (dest) {
    return absoluteRedirect(dest && dest.startsWith('/') ? dest : '/');
};
